export default "__VITE_ASSET__BQLgvdWR__"